/**
 * Centralized environment configuration for the mobile app.
 * All environment variables are defined here with their defaults.
 */

const config = {
	BACKEND_URL: import.meta.env.VITE_BACKEND_URL || 'http://localhost:3002',
	POSTHOG_KEY: import.meta.env.VITE_POSTHOG_KEY || '',
	POSTHOG_HOST: import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com',
	APP_ENV: import.meta.env.VITE_APP_ENV || 'development',
} as const;

export default config;
